import React from "react";
import { useParams, useLocation, useNavigate, Navigate } from "react-router";
import AuthManager from "../Common/AuthManager";

// v5's useHistory() returned push/replace/goBack methods; downstream
// components migrated from v5 still call these via props.history. Keep the
// same call shape so none of those components need to change.
function useHistoryCompat() {
  const navigate = useNavigate();
  return {
    push: (path, state) => navigate(path, { state }),
    replace: (path, state) => navigate(path, { replace: true, state }),
    goBack: () => navigate(-1),
  };
}

// Compatibility shim: v5's <Route component={X}> injected {match, location,
// history} as props. v7's element={} pattern doesn't inject anything, so we
// reconstruct the same shape here via hooks and pass it down unchanged —
// this lets every existing downstream component (many components deep, in
// some cases) keep reading props.match.params / props.location / props.history
// exactly as before, with zero changes to their own code.
const PrivateRoute = ({ component: Component, layout: Layout }) => {
  const params = useParams();
  const location = useLocation();
  const history = useHistoryCompat();

  if (!AuthManager.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const compatProps = { match: { params }, location, history };
  return (
    <Layout>
      <Component {...compatProps} />
    </Layout>
  );
};

export default PrivateRoute;
